import { useState, useMemo } from 'react'
/**
 * This helper gets the text from a rendered node to use as an aria-label.
 *
 * **Why does this even exist?** Sometimes people pass in JSX for certain label elements that usually require a string,
 * and sometimes we need to use the text content of said element in an aria-label instead of using aria-labelledby
 * since aria-labelledby does not always work as we want it.
 */
export default function useA11yLabelRef(
  label?: string | unknown
): [effectiveLabel: string, labelRef: (node: HTMLElement) => HTMLElement] {
  const [fallback, setFallback] = useState<string>()
  const effectiveLabel = typeof label === 'string' ? label : fallback
  return useMemo(
    () => [
      effectiveLabel,
      (node) => {
        setFallback(node?.textContent)
        return node
      },
    ],
    [effectiveLabel]
  )
}
